import React from "react";

import Radio from "antd/es/radio";
import Space from "antd/es/space";
import { useIntl } from "react-intl";

import PinLegendCreationVisibility from "@mapmycustomers/shared/enum/PinLegendCreationVisibility";

import RadioGroup from "@app/component/input/RadioGroup";
import { getPinLegendCreationVisibilityDisplayName } from "@app/util/ui";

interface Props {
  className?: string;
  onChange?: (visibility: PinLegendCreationVisibility) => void;
  value?: PinLegendCreationVisibility;
}

const CreationVisibility: React.FC<Props> = ({ className, onChange, value }) => {
  const intl = useIntl();
  return (
    <RadioGroup
      onChange={onChange}
      size="small"
      value={value ?? PinLegendCreationVisibility.PRIVATE}
    >
      <Space className={className} direction="vertical">
        {[
          PinLegendCreationVisibility.PRIVATE,
          PinLegendCreationVisibility.SHARED_WITH_MANAGERS,
          PinLegendCreationVisibility.SHARED_WITH_ORGANIZATION,
        ].map((visibility) => (
          <Radio key={visibility} value={visibility}>
            {getPinLegendCreationVisibilityDisplayName(
              intl,
              visibility as PinLegendCreationVisibility
            )}
          </Radio>
        ))}
      </Space>
    </RadioGroup>
  );
};

export default CreationVisibility;
